"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonEqualityCheck = void 0;
class JsonEqualityCheck {
    check(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }
}
exports.JsonEqualityCheck = JsonEqualityCheck;
//# sourceMappingURL=JsonEqualityCheck.js.map